const navFunc = (gsap, mm) => {
	
	// Hamburger/Mobile menu
	const siteNav = document.querySelector('.site-nav');
	const menuToggle = document.querySelector('.site-hamburger button');
	
	mm.add("(min-width: 768px)", () => {
		// desktop setup code here...
		if (siteNav.classList.contains('active')) {
			siteNav.classList.toggle('active');
		}
	});

	mm.add("(max-width: 767px)", () => {
		// mobile setup code here...
		menuToggle.addEventListener('click', function(ev) {
			ev.preventDefault();
			siteNav.classList.toggle('active');
		});

	});
	
	//Sticky header
	const header = document.getElementById("header");
	const intercept = document.createElement("div");

	intercept.setAttribute("data-observer-intercept", "");
	header.before(intercept);

	const observer = new IntersectionObserver(([entry]) => {
		header.classList.toggle("scrolled", !entry.isIntersecting);
	});

	observer.observe(intercept);

	
	//Download Slide
	//let downloadBtn = document.querySelectorAll( '.downloadCTA a, .mobile-close' );
	//const downloadSlide = document.querySelector('.download-slide');
	//const closeModal = document.querySelector('.close-modal');
	
	//[].forEach.call( downloadBtn, function ( a ) {
	//	a.addEventListener( 'click', function (ev) {
	//		ev.preventDefault();
	//		downloadSlide.classList.toggle('active');
	//		closeModal.classList.toggle('active');
	//	}, false );
	//});
	
	//closeModal.addEventListener('click', function(ev) {
	//	ev.preventDefault();
	//	downloadSlide.classList.toggle('active');
	//	closeModal.classList.toggle('active');
	//});
	
}

export {
	navFunc
};
